import { render, staticRenderFns } from "./ppDataTable.vue?vue&type=template&id=73b1647b&"
import script from "./ppDataTable.vue?vue&type=script&lang=js&"
export * from "./ppDataTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports